import { createSlice } from '@reduxjs/toolkit';

// types
import { SnackbarProps } from 'types/snackbar';

const initialState: SnackbarProps = {
    action: false,
    open: false,
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    variant: 'alert',
    alert: {
        color: 'primary',
        variant: 'filled'
    },
    transition: 'SlideRight',
    close: true,
    actionButton: false,
    autoHideDuration: 1500
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        
        openGeneralAlertSnackbar (state, action)  {
            // console.log(action.payload);
            const {  message, handleSnackbarClosed, success, isDelete } = action.payload;
            state.action = !state.action;
            state.open = true;

            if (message) {
                state.message = message;
            } else if (success) {
                state.message = isDelete ?'Successfully deleted' :'Changes successfully saved';
            } else {
                state.message = isDelete ? 'Deleting failed' :'Failed saving changes';
            } 

        //     ShowAlert(true, 'Successfully deleted');
        // } else {
        //     ShowAlert(false, 'Deleting failed');

            state.anchorOrigin = initialState.anchorOrigin;
            state.variant = initialState.variant;
            state.alert = {
                color: success ? 'success' : 'error',
                variant: initialState.alert.variant
            };
            state.transition = initialState.transition;
            state.close = initialState.close;
            state.actionButton = initialState.actionButton;
            state.autoHideDuration = initialState.autoHideDuration;
            state.handleSnackbarClosed = handleSnackbarClosed;
    },
        openSnackbar(state, action) {
            const { open, message, anchorOrigin, variant, alert, transition, close, actionButton, handleSnackbarClosed, autoHideDuration } =
                action.payload;

            state.action = !state.action;
            state.open = open || initialState.open;

            if (message) {
                state.message = message;
            } else if (alert?.color == 'success') {
                state.message = 'Changes successfully saved';
            } else if (alert?.color == 'error') {
                state.message = 'Failed saving changes';
            } else {
                state.message = initialState.message;
            }

            state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
            state.variant = variant || initialState.variant;
            state.alert = {
                color: alert?.color || initialState.alert.color,
                variant: alert?.variant || initialState.alert.variant
            };
            state.transition = transition || initialState.transition;
            state.close = close === false ? close : initialState.close;
            state.actionButton = actionButton || initialState.actionButton;
            state.autoHideDuration = autoHideDuration || initialState.autoHideDuration;
            state.handleSnackbarClosed = handleSnackbarClosed;
        },

        closeSnackbar(state) {
            state.open = false;
        }
    }
});

export default snackbar.reducer;

export const { closeSnackbar, openSnackbar ,openGeneralAlertSnackbar} = snackbar.actions;
